import { boolean } from "fp-ts";
import { flow } from "fp-ts/lib/function";

/**
 * @description Call g on the result of calling f on a value of type A
 * @param g A function from type B to type C.
 * @param f A function from type A to type B.
 * @returns A function from type A to type C
 */
export const andThen =
  <B, C>(g: (b: B) => C) =>
  <A>(f: (a: A) => B) =>
  (a: A) =>
    g(f(a));

export const allEqual =
  <T>(eq: (a: T, b: T) => boolean) =>
  (array: T[]) => {
    if (array.length <= 1) return true;
    const firstElement = array[0];
    return array.every((element) => eq(firstElement, element));
  };
